export const roots = new Map<string, [string, string]>([
  ['ab', ['away from', 'Latin']],
  ['a', ['not, without', 'Greek']],
  ['abs', ['away from', 'Latin']],
  ['ac', ['atmovement to or toward; in addition to', 'Latin']],
  ['acerb', ['sharp, bitter, sour', 'Latin']],
  ['acid', ['sour or acid', 'Latin']],
  ['acr', ['bitter, pungent, sharp, sour', 'Latin']],
  ['acu', ['sharp', 'Latin']],
  ['ad', ['atmovement to or toward; in addition to', 'Latin']],
  ['af', ['atmovement to or toward; in addition to', 'Latin']],
  ['ag', ['atmovement to or toward; in addition to', 'Latin']],
  ['al', ['atmovement to or toward; in addition to', 'Latin']],
  ['ap', ['away from, separate, at the farthest point', 'Greek']],
  ['ar', ['be dry', 'Latin']],
  ['as', ['atmovement to or toward; in addition to', 'Latin']],
  ['adip', ['fat', 'Latin']],
  ['aer', ['air, atmosphere', 'Greek']],
  ['aesthet', ['feeling, sensation', 'Greek']],
  ['agr', ['field', 'Greek']],
  ['agri', ['field', 'Latin']],
  ['alb', ['dull white', 'Latin']],
  ['am', ['love, loved', 'Latin']],
  ['amat', ['love, loved', 'Latin']],
  ['amor', ['love, loved', 'Latin']],
  ['ambi', ['both, on both sides', 'Latin']],
  ['amic', ['friend', 'Latin']],
  ['amph', ['around, about, both, on both sides of, both kinds', 'Greek']],
  ['amphi', ['around, about, both, on both sides of, both kinds', 'Greek']],
  ['ampl', ['ample, abundant, bountiful', 'Latin']],
  ['an', ['not, without', 'Greek']],
  ['ἀν', ['"not" anhydrous, atypical ana-, an- again, against, back, up', 'Greek']],
  ['andr', ['male, masculine', 'Greek']],
  ['anem', ['wind', 'Greek']],
  ['anim', ['breath', 'Latin']],
  ['ann', ['year, yearly', 'Latin']],
  ['ant', ['against, opposed to, preventive', 'Greek']],
  ['anti', ['before, in front of, prior to', 'Latin']],
  ['ante', ['before, in front of, prior to', 'Latin']],
  ['anth', ['flower', 'Greek']],
  ['anthrop', ['human', 'Greek']],
  ['apo', ['away from, separate, at the farthest point', 'Greek']],
  ['un', ['one', 'Latin']],
  ['arche', ['ruler', 'Greek']],
  ['archi', ['ruler', 'Greek']],
  ['ἀρχε', ['archangel, archetype archae-, arche- ancient', 'Greek']],
  ['ἀρχι', ['archangel, archetype archae-, arche- ancient', 'Greek']],
  ['arct', ['Relating to the North Pole or the region near it; relating to cold; used as the scientific name of some bear species, e.g. Ursus arctos horribilis', 'Greek']],
  ['argent', ['silver', 'Latin']],
  ['arist', ['excellence', 'Greek']],
  ['arthr', ['joint', 'Greek']],
  ['astr', ['star, star-shaped', 'Greek']],
  ['athl', ['prize', 'Greek']],
  ['audi', ['hearing, listening, sound', 'Latin']],
  ['aug', ['grow, increase', 'Latin']],
  ['auct', ['grow, increase', 'Latin']],
  ['aur', ['relating to gold, or gold-colored', 'Latin']],
  ['auri', ['relating to the ear', 'Latin']],
  ['aut', ['self; directed from within', 'Greek']],
  ['auto', ['self; directed from within', 'Greek']],
  ['avi', ['bird', 'Latin']],
  ['axi', ['axis', 'Latin']],
  ['axio', ['merit', 'Greek']],
  ['bac', ['shaped', 'Latin']],
  ['rod', ['gnaw', 'Latin']],
  ['bar', ['weight, pressure', 'Greek']],
  ['basi', ['at the bottom', 'Greek']],
  ['bathy', ['deep, depth', 'Greek']],
  ['batho', ['deep, depth', 'Greek']],
  ['be', ['bless', 'Latin']],
  ['beat', ['bless', 'Latin']],
  ['bell', ['war', 'Latin']],
  ['ben', ['good, well', 'Latin']],
  ['bi', ['two', 'Latin']],
  ['bib', ['drink', 'Latin']],
  ['bibl', ['book', 'Greek']],
  ['bio', ['life', 'Greek']],
  ['blenn', ['slime', 'Greek']],
  ['blast', ['germ, embryo, bud, cell with nucleus', 'Greek']],
  ['bon', ['good', 'Latin']],
  ['bor', ['north', 'Greek']],
  ['botan', ['plant', 'Greek']],
  ['bov', ['cow, ox', 'Latin']],
  ['brachi', ['arm', 'Greek']],
  ['brachy', ['short', 'Greek']],
  ['brady', ['slow', 'Greek']],
  ['branchi', ['gill', 'Greek']],
  ['brev(i)', ['brief, short (time)', 'Latin']],
  ['briz', ['nod, slumber', 'Greek']],
  ['brom', ['stench', 'Greek']],
  ['bronch', ['windpipe', 'Greek']],
  ['bront', ['thunder', 'Greek']],
  ['bucc', ['cheek, mouth, cavity', 'Latin']],
  ['bulb', ['bulbous', 'Latin']],
  ['bull', ['bubble, flask', 'Latin']],
  ['burs', ['pouch, purse', 'Latin']],
  ['cac', ['bad', 'Greek']],
  ['cad', ['fall', 'Latin']],
  ['cas', ['fall', 'Latin']],
  ['caed', ['cut', 'Latin']],
  ['caes', ['cut', 'Latin']],
  ['calc', ['stone', 'Latin']],
  ['call', ['beautiful', 'Greek']],
  ['calli', ['beautiful', 'Greek']],
  ['calor', ['heat', 'Latin']],
  ['calyp', ['cover', 'Greek']],
  ['camer', ['vault', 'Latin']],
  ['camp', ['field', 'Latin']],
  ['can', ['sing', 'Latin']],
  ['cant', ['sing', 'Latin']],
  ['cand', ['glowing, iridescent', 'Latin']],
  ['cap', ['hold, take', 'Latin']],
  ['capt', ['hold, take', 'Latin']],
  ['capit', ['head', 'Latin']],
  ['capr', ['goat', 'Latin']],
  ['caps', ['box, case', 'Latin']],
  ['carbo', ['coal', 'Latin']],
  ['carcer', ['jail', 'Latin']],
  ['carcin', ['cancer (disease)', 'Latin']],
  ['cardi', ['relating to the heart', 'Greek']],
  ['cardin', ['hinge', 'Latin']],
  ['carn', ['flesh', 'Latin']],
  ['carp', ['relating to the wrist', 'Greek']],
  ['cast', ['pure', 'Latin']],
  ['cata', ['down', 'Greek']],
  ['cat', ['down', 'Greek']],
  ['caten', ['chain', 'Latin']],
  ['cathar', ['pure', 'Greek']],
  ['caud', ['tail', 'Latin']],
  ['caus', ['cause or motive', 'Latin']],
  ['cav', ['hollow', 'Latin']],
  ['ced', ['go', 'Latin']],
  ['cess', ['go', 'Latin']],
  ['celer', ['quick', 'Latin']],
  ['cen', ['empty', 'Greek']],
  ['cens', ['', 'Latin']],
  ['cent', ['hundred', 'Latin']],
  ['centen', ['hundred each', 'Latin']],
  ['centesim', ['hundredth', 'Latin']],
  ['centr', ['center', 'Greek']],
  ['cephal', ['head', 'Greek']],
  ['ceram', ['clay', 'Greek']],
  ['cerat', ['horn', 'Greek']],
  ['cern', ['sift', 'Latin']],
  ['cervic', ['relating to the neck, relating to the cervix', 'Latin']],
  ['ceter', ['other', 'Latin']],
  ['chir', ['of the hand or hands', 'Greek']],
  ['chelon', ['relating to a turtle', 'Greek']],
  ['chlor', ['green', 'Greek']],
  ['chore', ['relating to dance', 'Greek']],
  ['chord', ['cord', 'Latin']],
  ['chrom', ['color', 'Greek']],
  ['chron', ['time', 'Greek']],
  ['chrys', ['gold', 'Greek']],
  ['cili', ['eyelash', 'Latin']],
  ['cine', ['motion', 'Greek']],
  ['ciner', ['ash', 'Latin']],
  ['cing', ['gird', 'Latin']],
  ['cinct', ['gird', 'Latin']],
  ['circ', ['circle', 'Latin']],
  ['circum', ['around', 'Latin']],
  ['cirr', ['curl, tentacle', 'Latin']],
  ['civ', ['citizen', 'Latin']],
  ['clad', ['branch', 'Greek']],
  ['clar', ['clear', 'Latin']],
  ['clast', ['broken', 'Greek']],
  ['claud', ['close', 'Latin']],
  ['claus', ['close', 'Latin']],
  ['clav', ['key', 'Greek']],
  ['cl(e)ist', ['closed', 'Greek']],
  ['cleithr', ['bar, key', 'Greek']],
  ['clement', ['mild', 'Latin']],
  ['clin', ['bed, lean, recline', 'Latin']],
  ['cochl', ['shell', 'Greek']],
  ['coel', ['hollow', 'Greek']],
  ['cogn', ['know', 'Latin']],
  ['col', ['with, together', 'Latin']],
  ['coll', ['neck', 'Latin']],
  ['color', ['color', 'Latin']],
  ['con', ['cone', 'Greek']],
  ['co', ['with, together', 'Latin']],
  ['com', ['with, together', 'Latin']],
  ['cor', ['with, together', 'Latin']],
  ['condi', ['season', 'Latin']],
  ['contra', ['against', 'Latin']],
  ['copr', ['dung', 'Greek']],
  ['corac', ['raven', 'Greek']],
  ['cord', ['heart', 'Latin']],
  ['corn', ['horn', 'Latin']],
  ['coron', ['crown', 'Latin']],
  ['corpor', ['body', 'Latin']],
  ['cortic', ['bark', 'Latin']],
  ['cosm', ['universe', 'Greek']],
  ['cosmet', ['', 'Greek']],
  ['κοσμητ', ['cosmetics, cosmetology cost- rib', 'Latin']],
  ['(kosmet', ['cosmetics, cosmetology cost- rib', 'Latin']],
  ['cotyl', ['cup', 'Greek']],
  ['crani', ['skull', 'Greek']],
  ['crass', ['thick', 'Latin']],
  ['cre', ['make', 'Latin']],
  ['cred', ['believe, trust', 'Latin']],
  ['crep', ['boot, shoe', 'Greek']],
  ['cribr', ['sieve', 'Latin']],
  ['cris', ['judge', 'Greek']],
  ['crit', ['judge', 'Greek']],
  ['crisp', ['curled', 'Latin']],
  ['crist', ['crest', 'Latin']],
  ['cross', ['fringe, tassel', 'Greek']],
  ['cruc', ['cross', 'Latin']],
  ['crur', ['leg, shank', 'Latin']],
  ['crypt', ['hidden', 'Greek']],
  ['cten', ['comb', 'Greek']],
  ['cub', ['lie', 'Latin']],
  ['culin', ['kitchen', 'Latin']],
  ['culp', ['blame, fault', 'Latin']],
  ['cune', ['wedge', 'Latin']],
  ['curr', ['run', 'Latin']],
  ['curs', ['run', 'Latin']],
  ['curv', ['bent', 'Latin']],
  ['cuspid', ['lance, point', 'Latin']],
  ['cut', ['skin', 'Latin']],
  ['cyan', ['blue', 'Greek']],
  ['cycl', ['circular', 'Greek']],
  ['cylind', ['roll', 'Greek']],
  ['cyn', ['dog', 'Greek']],
  ['cyst', ['capsule', 'Greek']],
  ['cyt', ['cell', 'Greek']],
  ['dactyl', ['finger, toe, digit', 'Greek']],
  ['damn', ['to inflict loss upon', 'Latin']],
  ['de', ['from, away from, removing, down', 'Latin']],
  ['deb', ['owe', 'Latin']],
  ['deca', ['ten', 'Greek']],
  ['dec', ['ten', 'Greek']],
  ['deka', ['ten', 'Greek']],
  ['dek', ['ten', 'Greek']],
  ['decim', ['tenth part', 'Latin']],
  ['delt', ['', 'Greek']],
  ['dem', ['people', 'Greek']],
  ['den', ['ten each', 'Latin']],
  ['dendr', ['resembling a tree', 'Greek']],
  ['dens', ['thick', 'Latin']],
  ['dent', ['tooth', 'Latin']],
  ['derm', ['skin', 'Greek']],
  ['deuter', ['second', 'Greek']],
  ['dexter', ['right', 'Latin']],
  ['dexi', ['right', 'Greek']],
  ['di', ['two', 'Greek']],
  ['δι', ['dicot, diode, dipole dia- apart, through', 'Greek']],
  ['dict', ['say, speak', 'Latin']],
  ['digit', ['finger', 'Latin']],
  ['dino', ['terrible, fearfully great', 'Greek']],
  ['dipl', ['double; twofold', 'Greek']],
  ['doc', ['teach', 'Latin']],
  ['doct', ['teach', 'Latin']],
  ['dodec', ['twelve', 'Greek']],
  ['dogmat', ['opinion, tenet', 'Greek']],
  ['dox', ['opinion, tenet', 'Greek']],
  ['dom', ['house', 'Latin']],
  ['don', ['give', 'Latin']],
  ['dorm', ['sleep', 'Latin']],
  ['dors', ['back', 'Latin']],
  ['du', ['two', 'Latin']],
  ['dub', ['doubtful', 'Latin']],
  ['duc', ['lead', 'Latin']],
  ['duct', ['lead', 'Latin']],
  ['dulc', ['sweet', 'Latin']],
  ['dur', ['hard', 'Latin']],
  ['dy', ['two', 'Greek']],
  ['dynam', ['power', 'Greek']],
  ['dys', ['badly, ill', 'Greek']],
  ['δυσ', ['dysentery, dysplasia, dystrophy E Root Meaning in English Origin language Etymology (root origin) English examples ec- out', 'Greek']],
  ['eco', ['house', 'Greek']],
  ['ecto', ['outside', 'Greek']],
  ['ed', ['eat', 'Latin']],
  ['es', ['eat', 'Latin']],
  ['ego', ['goat', 'Greek']],
  ['eg', ['goat', 'Greek']],
  ['em', ['in', 'Greek']],
  ['empt', ['buy', 'Latin']],
  ['eme', ['vomit', 'Greek']],
  ['emul', ['striving to equal, rivaling', 'Latin']],
  ['en', ['in', 'Greek']],
  ['endo', ['inside', 'Greek']],
  ['engy', ['narrow', 'Greek']],
  ['ennea', ['nine', 'Greek']],
  ['ens', ['sword', 'Latin']],
  ['eo', ['dawn, east', 'Greek']],
  ['eos', ['dawn, east', 'Greek']],
  ['eoso', ['dawn, east', 'Greek']],
  ['ep', ['upon', 'Greek']],
  ['epi', ['upon', 'Greek']],
  ['epistem', ['knowledge or science', 'Greek']],
  ['equ', ['horse', 'Latin']],
  ['erg', ['work', 'Greek']],
  ['err', ['stray', 'Latin']],
  ['erythr', ['red', 'Greek']],
  ['eso', ['within', 'Greek']],
  ['etho', ['custom, habit', 'Greek']],
  ['eth', ['custom, habit', 'Greek']],
  ['ethi', ['custom, habit', 'Greek']],
  ['ethm', ['sieve', 'Greek']],
  ['ethn', ['people, race, tribe, nation', 'Greek']],
  ['etym', ['true', 'Greek']],
  ['eu', ['well, good', 'Greek']],
  ['eur', ['wide', 'Greek']],
  ['ex', ['from, out', 'Latin']],
  ['e', ['from, out', 'Latin']],
  ['ef', ['from, out', 'Latin']],
  ['exo', ['outside', 'Greek']],
  ['exter', ['outer', 'Latin']],
  ['extra', ['outer', 'Latin']],
  ['extrem', ['outermost, utmost', 'Latin']],
  ['f', ['say, speak', 'Latin']],
  ['fat', ['say, speak', 'Latin']],
  ['fab', ['bean', 'Latin']],
  ['fac', ['fact, -fect- make', 'Latin']],
  ['falc', ['sickle', 'Latin']],
  ['fall', ['deceive', 'Latin']],
  ['fals', ['deceive', 'Latin']],
  ['fallac', ['false', 'Latin']],
  ['famili', ['a close attendant', 'Latin']],
  ['fant', ['to show', 'Greek']],
  ['fasc', ['bundle', 'Latin']],
  ['fatu', ['foolish, useless', 'Latin']],
  ['feder', ['treaty, agreement, contract, league, pact', 'Latin']],
  ['fel', ['cat', 'Latin']],
  ['felic', ['happy, merry', 'Latin']],
  ['fell', ['suck', 'Latin']],
  ['femin', ['women, female', 'Latin']],
  ['femor', ['thigh', 'Latin']],
  ['fend', ['strike', 'Latin']],
  ['fens', ['strike', 'Latin']],
  ['fenestr', ['window', 'Latin']],
  ['fer', ['carry', 'Latin']],
  ['feroc', ['fierce', 'Latin']],
  ['ferr', ['iron', 'Latin']],
  ['fet', ['stink', 'Latin']],
  ['fic', ['fig', 'Latin']],
  ['fid', ['faith, trust', 'Latin']],
  ['fis', ['faith, trust', 'Latin']],
  ['fil', ['thread', 'Latin']],
  ['fili', ['son', 'Latin']],
  ['fin', ['end', 'Latin']],
  ['find', ['split', 'Latin']],
  ['fiss', ['split', 'Latin']],
  ['firm', ['fix, settle', 'Latin']],
  ['fistul', ['hollow, tube', 'Latin']],
  ['fl', ['blow', 'Latin']],
  ['flacc', ['flabby', 'Latin']],
  ['flav', ['yellow', 'Latin']],
  ['flect', ['bend', 'Latin']],
  ['flex', ['bend', 'Latin']],
  ['flig', ['strike', 'Latin']],
  ['flict', ['strike', 'Latin']],
  ['flor', ['flower', 'Latin']],
  ['flu', ['flow', 'Latin']],
  ['flux', ['flow', 'Latin']],
  ['foc', ['hearth', 'Latin']],
  ['fod', ['dig', 'Latin']],
  ['foss', ['dig', 'Latin']],
  ['foen', ['hay', 'Latin']],
  ['foli', ['leaf', 'Latin']],
  ['font', ['spring', 'Latin']],
  ['for', ['bore, drill', 'Latin']],
  ['form', ['shape', 'Latin']],
  ['fornic', ['vault', 'Latin']],
  ['fort', ['strong', 'Latin']],
  ['fove', ['shallow round depression', 'Latin']],
  ['frang', ['break', 'Latin']],
  ['fract', ['break', 'Latin']],
  ['frag', ['break', 'Latin']],
  ['frater', ['brother', 'Latin']],
  ['fratr', ['brother', 'Latin']],
  ['fric', ['rub', 'Latin']],
  ['frict', ['rub', 'Latin']],
  ['frig', ['cold', 'Latin']],
  ['front', ['forehead', 'Latin']],
  ['fruct', ['fruit', 'Latin']],
  ['frug', ['fruit', 'Latin']],
  ['fug', ['flee', 'Latin']],
  ['fugit', ['flee', 'Latin']],
  ['fum', ['smoke', 'Latin']],
  ['fund', ['pour', 'Latin']],
  ['fus', ['pour', 'Latin']],
  ['fung', ['do', 'Latin']],
  ['funct', ['do', 'Latin']],
  ['fur', ['steal', 'Latin']],
  ['furt', ['steal', 'Latin']],
  ['furc', ['fork', 'Latin']],
  ['fusc', ['dark', 'Latin']],
  ['galact', ['milk', 'Greek']],
  ['gastr', ['stomach', 'Greek']],
  ['geo', ['earth', 'Greek']],
  ['γεω', ['geography, geology, geometry gel- icy cold', 'Latin']],
  ['(geō', ['geography, geology, geometry gel- icy cold', 'Latin']],
  ['gen', ['race, kind,birth', 'Greek']],
  ['ger', ['bear, carry', 'Latin']],
  ['gest', ['bear, carry', 'Latin']],
  ['germin', ['sprout', 'Latin']],
  ['glabr', ['hairless', 'Latin']],
  ['glaci', ['ice', 'Latin']],
  ['gladi', ['sword', 'Latin']],
  ['glia', ['glue', 'Greek']],
  ['glob', ['sphere', 'Latin']],
  ['glori', ['glory', 'Latin']],
  ['glutin', ['glue', 'Latin']],
  ['grad', ['walk, step, go', 'Latin']],
  ['gress', ['walk, step, go', 'Latin']],
  ['gram', ['writing', 'Greek']],
  ['gran', ['grain', 'Latin']],
  ['grand', ['grand', 'Latin']],
  ['graph', ['draw, write', 'Greek']],
  ['grat', ['thank, please', 'Latin']],
  ['grav', ['heavy', 'Latin']],
  ['greg', ['flock', 'Latin']],
  ['gubern', ['govern, pilot', 'Latin']],
  ['gust', ['taste', 'Latin']],
  ['gutt', ['drop', 'Latin']],
  ['guttur', ['throat', 'Latin']],
  ['gymn', ['nude', 'Greek']],
  ['gyn', ['woman', 'Greek']],
  ['hab', ['have', 'Latin']],
  ['habit', ['have', 'Latin']],
  ['haem', ['blood', 'Greek']],
  ['hem', ['blood', 'Greek']],
  ['hal', ['breathe', 'Latin']],
  ['hapl', ['simple, single', 'Greek']],
  ['haur', ['draw', 'Latin']],
  ['haust', ['draw', 'Latin']],
  ['heli', ['sun', 'Greek']],
  ['hemi', ['half', 'Greek']],
  ['hen', ['one', 'Greek']],
  ['hendec', ['eleven', 'Greek']],
  ['hept', ['seven', 'Greek']],
  ['her', ['cling', 'Latin']],
  ['hes', ['cling', 'Latin']],
  ['herb', ['grass', 'Latin']],
  ['hered', ['heir', 'Latin']],
  ['herp', ['creep', 'Greek']],
  ['heter', ['different, other', 'Greek']],
  ['heur', ['find', 'Greek']],
  ['hex', ['six', 'Greek']],
  ['hibern', ['wintry', 'Latin']],
  ['hiem', ['winter', 'Latin']],
  ['hipp', ['horse', 'Greek']],
  ['hirsut', ['hairy', 'Latin']],
  ['hispid', ['bristly', 'Latin']],
  ['histri', ['actor', 'Latin']],
  ['hod', ['way', 'Greek']],
  ['hol', ['whole', 'Greek']],
  ['hom', ['same', 'Greek']],
  ['home', ['like', 'Greek']],
  ['homin', ['human', 'Latin']],
  ['homal', ['even, flat', 'Greek']],
  ['honor', ['esteem', 'Latin']],
  ['hor', ['hour', 'Greek']],
  ['horm', ['that which excites', 'Greek']],
  ['hort', ['garden', 'Latin']],
  ['hospit', ['host', 'Latin']],
  ['host', ['enemy', 'Latin']],
  ['hum', ['ground', 'Latin']],
  ['hyal', ['glass', 'Greek']],
  ['hydr', ['water', 'Greek']],
  ['hygr', ['wet', 'Greek']],
  ['hyo', ['shaped', 'Greek']],
  ['U', ['shaped', 'Greek']],
  ['hyp', ['under', 'Greek']],
  ['hyper', ['above, over', 'Greek']],
  ['hypn', ['sleep', 'Greek']],
  ['hyster', ['later', 'Greek']],
  ['ichthy', ['fish', 'Greek']],
  ['icos', ['twenty', 'Greek']],
  ['id', ['shape', 'Greek']],
  ['ide', ['idea; thought', 'Greek']],
  ['idi', ['personal', 'Greek']],
  ['ign', ['fire', 'Latin']],
  ['in', ['illicit, impossible, inimical, irrational infra- below, under', 'Latin']],
  ['insul', ['island', 'Latin']],
  ['inter', ['among, between', 'Latin']],
  ['intra', ['within', 'Latin']],
  ['irasc', ['be angry', 'Latin']],
  ['irat', ['be angry', 'Latin']],
  ['is', ['equal, the same', 'Greek']],
  ['iso', ['equal, the same', 'Greek']],
  ['iter', ['again', 'Latin']],
  ['itiner', ['route, way', 'Latin']],
  ['jac', ['(originally IAC), -ject- cast, throw', 'Latin']],
  ['janu', ['door', 'Latin']],
  ['joc', ['joke', 'Latin']],
  ['jug', ['yoke', 'Latin']],
  ['jung', ['join', 'Latin']],
  ['junct', ['join', 'Latin']],
  ['junior', ['younger', 'Latin']],
  ['jus', ['law, justice', 'Latin']],
  ['jur', ['law, justice', 'Latin']],
  ['judic', ['law, justice', 'Latin']],
  ['juv', ['help', 'Latin']],
  ['jut', ['help', 'Latin']],
  ['juven', ['young, youth', 'Latin']],
  ['juxta', ['beside, near', 'Latin']],
  ['kil(o)', ['thousand', 'Greek']],
  ['kine', ['movement, motion', 'Greek']],
  ['klept', ['steal', 'Greek']],
  ['kudo', ['glory', 'Greek']],
  ['lab', ['slide, slip', 'Latin']],
  ['laps', ['slide, slip', 'Latin']],
  ['labi', ['lip', 'Latin']],
  ['labor', ['toil', 'Latin']],
  ['lacer', ['tear', 'Latin']],
  ['lacrim', ['cry, tears', 'Latin']],
  ['lact', ['milk', 'Latin']],
  ['lamin', ['layer, slice', 'Latin']],
  ['lamp', ['shine', 'Greek']],
  ['lapid', ['stone', 'Latin']],
  ['larg', ['large', 'Latin']],
  ['larv', ['ghost, mask', 'Latin']],
  ['lat', ['broad, wide', 'Latin']],
  ['later', ['side', 'Latin']],
  ['laud', ['praise', 'Latin']],
  ['laus', ['praise', 'Latin']],
  ['lav', ['wash', 'Latin']],
  ['lax', ['not tense', 'Latin']],
  ['led', ['hurt', 'Latin']],
  ['les', ['hurt', 'Latin']],
  ['leg', ['send', 'Latin']],
  ['lei', ['smooth', 'Greek']],
  ['lekan', ['dish, pot', 'Greek']],
  ['leni', ['gentle', 'Latin']],
  ['leon', ['lion', 'Latin']],
  ['lep', ['flake, scale', 'Greek']],
  ['leps', ['grasp, seize', 'Greek']],
  ['leuc(o)', ['white', 'Greek']],
  ['leuk(o)', ['white', 'Greek']],
  ['lev', ['lift, light', 'Latin']],
  ['liber', ['free', 'Latin']],
  ['libr', ['book', 'Latin']],
  ['lig', ['bind', 'Latin']],
  ['limac', ['slug', 'Latin']],
  ['lin', ['line', 'Latin']],
  ['lingu', ['language, tongue', 'Latin']],
  ['linqu', ['leave', 'Latin']],
  ['lict', ['leave', 'Latin']],
  ['lip', ['fat', 'Greek']],
  ['liter', ['letter', 'Latin']],
  ['lith', ['stone', 'Greek']],
  ['loc', ['place', 'Latin']],
  ['log', ['thought, word, speech', 'Greek']],
  ['long', ['long', 'Latin']],
  ['loqu', ['speak', 'Latin']],
  ['locut', ['speak', 'Latin']],
  ['luc', ['bright, light', 'Latin']],
  ['lud', ['play', 'Latin']],
  ['lus', ['play', 'Latin']],
  ['lumin', ['light', 'Latin']],
  ['lun', ['moon', 'Latin']],
  ['macro', ['long', 'Greek']],
  ['magn', ['great, large', 'Latin']],
  ['maj', ['greater', 'Latin']],
  ['mal', ['bad, wretched,', 'Latin']],
  ['mamm', ['breast', 'Latin']],
  ['man', ['stay', 'Latin']],
  ['mand', ['hand', 'Latin']],
  ['manu', ['hand', 'Latin']],
  ['mar', ['sea', 'Latin']],
  ['mater', ['matrmother', 'Latin']],
  ['maxim', ['greatest', 'Latin']],
  ['medi', ['', 'Latin']],
  ['meg', ['great, large', 'Greek']],
  ['mei', ['less', 'Greek']],
  ['melan', ['black, dark', 'Greek']],
  ['melior', ['better', 'Latin']],
  ['mell', ['honey', 'Latin']],
  ['memor', ['remember', 'Latin']],
  ['mening', ['membrane', 'Greek']],
  ['men', ['month', 'Greek']],
  ['menstru', ['monthly', 'Latin']],
  ['mensur', ['measure', 'Latin']],
  ['ment', ['mind', 'Latin']],
  ['mer', ['part', 'Greek']],
  ['merc', ['reward, wages, hire', 'Latin']],
  ['merg', ['mersdip, plunge', 'Latin']],
  ['mes', ['middle', 'Greek']],
  ['meter', ['metrmeasure', 'Greek']],
  ['meta', ['above, among, beyond', 'Greek']],
  ['mic', ['grain', 'Latin']],
  ['micr', ['small', 'Greek']],
  ['migr', ['wander', 'Latin']],
  ['milit', ['soldier', 'Latin']],
  ['mill', ['thousand', 'Latin']],
  ['millen', ['thousand each', 'Latin']],
  ['mim', ['repeat', 'Greek']],
  ['min', ['less, smaller', 'Latin']],
  ['mir', ['wonder, amazement', 'Latin']],
  ['mis', ['hate', 'Greek']],
  ['misce', ['mixtmix', 'Latin']],
  ['mit', ['thread', 'Greek']],
  ['mitt', ['send', 'Latin']],
  ['miss', ['send', 'Latin']],
  ['mne', ['memory', 'Greek']],
  ['mol', ['grind', 'Latin']],
  ['moll', ['soft', 'Latin']],
  ['mon', ['one', 'Greek']],
  ['monil', ['string of beads', 'Latin']],
  ['mont', ['mountain', 'Latin']],
  ['mord', ['bite', 'Latin']],
  ['morph', ['form, shape', 'Greek']],
  ['mort', ['death', 'Latin']],
  ['mov', ['move, motion', 'Latin']],
  ['mot', ['move, motion', 'Latin']],
  ['mulg', ['milk', 'Latin']],
  ['muls', ['milk', 'Latin']],
  ['mult', ['many, much', 'Latin']],
  ['mur', ['wall', 'Latin']],
  ['mus', ['thief', 'Latin']],
  ['musc', ['fly', 'Latin']],
  ['mut', ['change', 'Latin']],
  ['my', ['mouse', 'Greek']],
  ['myri', ['countless, ten thousand', 'Greek']],
  ['myrmec', ['ant', 'Greek']],
  ['myth', ['story', 'Greek']],
  ['myx', ['slime', 'Greek']],
  ['myz', ['suck', 'Greek']],
  ['nar', ['nostril', 'Latin']],
  ['narc', ['numb', 'Greek']],
  ['narr', ['tell', 'Latin']],
  ['nas', ['nose', 'Latin']],
  ['nasc', ['born', 'Latin']],
  ['nat', ['born', 'Latin']],
  ['naut', ['ship', 'Greek']],
  ['nav', ['ship', 'Latin']],
  ['ne', ['new', 'Greek']],
  ['necr', ['dead', 'Greek']],
  ['nect', ['join, tie', 'Latin']],
  ['nex', ['join, tie', 'Latin']],
  ['neg', ['say no', 'Latin']],
  ['nema', ['hair', 'Greek']],
  ['nemor', ['grove, woods', 'Latin']],
  ['nephr', ['kidney', 'Greek']],
  ['nes', ['island', 'Greek']],
  ['neur', ['nerve', 'Greek']],
  ['nict', ['wink', 'Latin']],
  ['nigr', ['black', 'Latin']],
  ['nihil', ['nothing', 'Latin']],
  ['noct', ['night', 'Latin']],
  ['nod', ['knot', 'Latin']],
  ['nom', ['arrangement, law', 'Greek']],
  ['nomad', ['those who let pasture herds', 'Greek']],
  ['nomin', ['name', 'Latin']],
  ['non', ['ninth', 'Latin']],
  ['nonagen', ['ninety each', 'Latin']],
  ['nonagesim', ['ninetieth', 'Latin']],
  ['not', ['letter, note, paper', 'Latin']],
  ['noth', ['spurious', 'Greek']],
  ['noto', ['back, south', 'Greek']],
  ['nov', ['new', 'Latin']],
  ['noven', ['nine each', 'Latin']],
  ['novendec', ['nineteen', 'Latin']],
  ['nox', ['harmful', 'Latin']],
  ['noc', ['harmful', 'Latin']],
  ['nu', ['nod', 'Latin']],
  ['nub', ['to marry, to wed', 'Latin']],
  ['nuc', ['nut', 'Latin']],
  ['nuch', ['back of neck', 'Latin']],
  ['nud', ['naked', 'Latin']],
  ['null', ['none', 'Latin']],
  ['numer', ['number', 'Latin']],
  ['nunci', ['announce', 'Latin']],
  ['nupti', ['', 'Latin']],
  ['nutri', ['nourish', 'Latin']],
  ['ob', ['against', 'Latin']],
  ['o', ['against', 'Latin']],
  ['oc', ['against', 'Latin']],
  ['of', ['against', 'Latin']],
  ['og', ['against', 'Latin']],
  ['op', ['against', 'Latin']],
  ['os', ['against', 'Latin']],
  ['oct', ['eight', 'Latin']],
  ['octav', ['eighth', 'Latin']],
  ['octogen', ['eighty each', 'Latin']],
  ['octogesim', ['eightieth', 'Latin']],
  ['octon', ['eight each', 'Latin']],
  ['ocul', ['eye', 'Latin']],
  ['od', ['hate', 'Latin']],
  ['odont', ['tooth', 'Greek']],
  ['odor', ['fragrant', 'Latin']],
  ['oeco', ['house', 'Greek']],
  ['oed', ['swollen', 'Greek']],
  ['oen', ['wine', 'Greek']],
  ['oesophag', ['gullet', 'Greek']],
  ['ogdo', ['eighth', 'Greek']],
  ['(', ['oeidēs) asteroid, mucoid, organoid ole- oil', 'Latin']],
  ['olecran', ['skull of elbow', 'Latin']],
  ['olig', ['few', 'Greek']],
  ['oliv', ['olive', 'Latin']],
  ['omas', ['paunch', 'Latin']],
  ['oment', ['fat skin', 'Latin']],
  ['omin', ['creepy', 'Latin']],
  ['omm', ['eye', 'Greek']],
  ['omni', ['all', 'Latin']],
  ['omo', ['shoulder', 'Latin']],
  ['omphal', ['navel', 'Greek']],
  ['oner', ['burden', 'Latin']],
  ['onom', ['name', 'Greek']],
  ['ont', ['existing', 'Greek']],
  ['oo', ['egg', 'Greek']],
  ['opac', ['shady', 'Latin']],
  ['oper', ['work', 'Latin']],
  ['opercul', ['little cover', 'Latin']],
  ['ophi', ['snake', 'Greek']],
  ['ophthalm', ['eye', 'Greek']],
  ['opisth', ['behind', 'Greek']],
  ['opoter', ['either', 'Greek']],
  ['opt', ['choose', 'Latin']],
  ['optim', ['best', 'Latin']],
  ['or', ['mouth', 'Latin']],
  ['orb', ['circle', 'Latin']],
  ['orch', ['testicle', 'Greek']],
  ['ordin', ['order', 'Latin']],
  ['organ', ['organ, instrument, tool', 'Greek']],
  ['ori', ['eastern', 'Latin']],
  ['ort', ['eastern', 'Latin']],
  ['orn', ['decorate', 'Latin']],
  ['ornith', ['bird', 'Greek']],
  ['orth', ['straight', 'Greek']],
  ['oscill', ['swing', 'Latin']],
  ['oss', ['bone', 'Latin']],
  ['osteo', ['bone', 'Greek']],
  ['osti', ['entrance', 'Latin']],
  ['ostrac', ['shell', 'Greek']],
  ['ot', ['ear', 'Greek']],
  ['ov', ['egg', 'Latin']],
  ['ovi', ['sheep', 'Latin']],
  ['oxy', ['sharp, pointed', 'Greek']],
  ['pac', ['peace', 'Latin']],
  ['pach', ['thick', 'Greek']],
  ['paed', ['child', 'Greek']],
  ['pagin', ['page', 'Latin']],
  ['pal', ['stake', 'Latin']],
  ['palae', ['ancient, old', 'Greek']],
  ['pale', ['ancient, old', 'Greek']],
  ['palin', ['back', 'Greek']],
  ['pall', ['be pale', 'Latin']],
  ['palli', ['mantle', 'Latin']],
  ['palm', ['palm', 'Latin']],
  ['palustr', ['in marshes', 'Latin']],
  ['pan', ['all', 'Greek']],
  ['pam', ['all', 'Greek']],
  ['pand', ['spread', 'Latin']],
  ['pans', ['spread', 'Latin']],
  ['par(a)', ['beside, near', 'Greek']],
  ['pariet', ['wall', 'Latin']],
  ['part', ['part', 'Latin']],
  ['parthen', ['maiden', 'Greek']],
  ['parv', ['little', 'Latin']],
  ['pasc', ['feed', 'Latin']],
  ['past', ['feed', 'Latin']],
  ['pass', ['suffer, feel, endure, permit', 'Latin']],
  ['passer', ['sparrow', 'Latin']],
  ['pat', ['be open', 'Latin']],
  ['path', ['feel, hurt', 'Greek']],
  ['pati', ['suffer, feel, endure, permit', 'Latin']],
  ['patr', ['father', 'Latin']],
  ['pauc', ['few', 'Latin']],
  ['pav', ['', 'Latin']],
  ['pecc', ['sin', 'Latin']],
  ['pect', ['fixed', 'Greek']],
  ['pector', ['chest', 'Latin']],
  ['pecun', ['money', 'Latin']],
  ['ped', ['foot', 'Latin']],
  ['pejor', ['worse', 'Latin']],
  ['pell', ['drive', 'Latin']],
  ['puls', ['drive', 'Latin']],
  ['pen', ['almost', 'Latin']],
  ['pend', ['hang', 'Latin']],
  ['pens', ['hang', 'Latin']],
  ['penn', ['feather', 'Latin']],
  ['pinn', ['feather', 'Latin']],
  ['pent', ['five', 'Greek']],
  ['pentecost', ['fiftieth', 'Greek']],
  ['pept', ['to digest', 'Greek']],
  ['per', ['thoroughly, through', 'Latin']],
  ['peran', ['across, beyond', 'Greek']],
  ['peri', ['around', 'Greek']],
  ['persic', ['peach', 'Greek']],
  ['pessim', ['worst', 'Latin']],
  ['pet', ['strive towards', 'Latin']],
  ['petr', ['rock', 'Greek']],
  ['phae', ['dark', 'Greek']],
  ['phag', ['eat', 'Greek']],
  ['phalang', ['close formation of troops, finger bones', 'Greek']],
  ['phalar', ['having a patch of white', 'Greek']],
  ['pharmac', ['drug, medicine', 'Greek']],
  ['phaner', ['visible', 'Greek']],
  ['pher', ['bear, carry', 'Greek']],
  ['phil', ['love, friendship', 'Greek']],
  ['phleg', ['heat', 'Greek']],
  ['phloe', ['tree bark', 'Greek']],
  ['phob', ['fear', 'Greek']],
  ['phon', ['sound', 'Greek']],
  ['phor', ['carry, bear', 'Greek']],
  ['phos', ['light', 'Greek']],
  ['phot', ['light', 'Greek']],
  ['phragm', ['fence', 'Greek']],
  ['phren', ['diaphragm, mind', 'Greek']],
  ['phryn', ['toad, toad-like', 'Greek']],
  ['phyl', ['tribe', 'Greek']],
  ['phyll', ['leaf', 'Greek']],
  ['phys', ['nature', 'Greek']],
  ['physalid', ['bladder', 'Greek']],
  ['phyt', ['plant', 'Greek']],
  ['pic', ['pitch', 'Latin']],
  ['pil', ['hair', 'Latin']],
  ['pin', ['pine', 'Latin']],
  ['ping', ['paint', 'Latin']],
  ['pict', ['paint', 'Latin']],
  ['pingu', ['fat', 'Latin']],
  ['pir', ['pear', 'Latin']],
  ['pisc', ['fish', 'Latin']],
  ['pis', ['pea', 'Greek']],
  ['plac', ['please', 'Latin']],
  ['plagi', ['oblique', 'Greek']],
  ['plan', ['flat', 'Latin']],
  ['plang', ['', 'Latin']],
  ['planct', ['', 'Latin']],
  ['plas', ['mould', 'Greek']],
  ['platy', ['flat, broad', 'Greek']],
  ['plaud', ['approve, clap', 'Latin']],
  ['plaus', ['approve, clap', 'Latin']],
  ['ple', ['fill', 'Latin']],
  ['plet', ['fill', 'Latin']],
  ['pleb', ['people', 'Latin']],
  ['plec', ['interwoven', 'Greek']],
  ['plect', ['plait', 'Latin']],
  ['plex', ['plait', 'Latin']],
  ['plen', ['full', 'Latin']],
  ['plesi', ['near', 'Greek']],
  ['pleth', ['full', 'Greek']],
  ['pleur', ['side', 'Greek']],
  ['plic', ['fold', 'Latin']],
  ['plinth', ['brick', 'Greek']],
  ['plor', ['', 'Latin']],
  ['plu', ['rain', 'Latin']],
  ['plum', ['feather', 'Latin']],
  ['plumb', ['lead', 'Latin']],
  ['plur', ['more', 'Latin']],
  ['plurim', ['most', 'Latin']],
  ['plus', ['more', 'Latin']],
  ['plut', ['wealth', 'Greek']],
  ['pluvi', ['rain', 'Latin']],
  ['pneu', ['air, lung', 'Greek']],
  ['pod', ['foot', 'Greek']],
  ['pogon', ['beard', 'Greek']],
  ['poie', ['make', 'Greek']],
  ['pol', ['pole', 'Greek']],
  ['pole', ['city', 'Greek']],
  ['poli', ['grey', 'Greek']],
  ['polem', ['war', 'Greek']],
  ['pollic', ['thumb', 'Latin']],
  ['pollin', ['', 'Latin']],
  ['poly', ['many', 'Greek']],
  ['pon', ['put', 'Latin']],
  ['posit', ['put', 'Latin']],
  ['ponder', ['weight', 'Latin']],
  ['pont', ['bridge', 'Latin']],
  ['popul', ['people', 'Latin']],
  ['por', ['passage', 'Greek']],
  ['porc', ['pig', 'Latin']],
  ['porphyr', ['purple', 'Greek']],
  ['port', ['carry', 'Latin']],
  ['post', ['after, behind', 'Latin']],
  ['pot', ['drink', 'Latin']],
  ['potam', ['river', 'Greek']],
  ['prasin', ['green', 'Greek']],
  ['leek', ['green', 'Greek']],
  ['prat', ['meadow', 'Latin']],
  ['prav', ['crooked', 'Latin']],
  ['pre', ['before', 'Latin']],
  ['prec', ['pray', 'Latin']],
  ['pred', ['', 'Latin']],
  ['prehend', ['grasp', 'Latin']],
  ['prend', ['grasp', 'Latin']],
  ['prehens', ['grasp', 'Latin']],
  ['prem', ['press', 'Latin']],
  ['press', ['press', 'Latin']],
  ['presby', ['old', 'Greek']],
  ['preter', ['past', 'Latin']],
  ['preti', ['price', 'Latin']],
  ['prim', ['first', 'Latin']],
  ['prior', ['former', 'Latin']],
  ['priv(i)', ['separate', 'Latin']],
  ['pro', ['for, forward', 'Latin']],
  ['prob', ['try', 'Latin']],
  ['proct', ['anus', 'Greek']],
  ['propri', ['one\'s own, ownership', 'Latin']],
  ['pros', ['forward', 'Greek']],
  ['prot', ['first', 'Greek']],
  ['proxim', ['nearest', 'Latin']],
  ['prun', ['plum', 'Latin']],
  ['psamma', ['sand', 'Greek']],
  ['pseud', ['false', 'Greek']],
  ['psil', ['bare', 'Greek']],
  ['psych', ['mind', 'Greek']],
  ['psychr', ['cold', 'Greek']],
  ['pter', ['wing, fern', 'Greek']],
  ['pto', ['fall', 'Greek']],
  ['ptyal', ['saliva', 'Greek']],
  ['ptych', ['fold, layer', 'Greek']],
  ['pub', ['sexually mature', 'Latin']],
  ['public', ['', 'Latin']],
  ['pude', ['', 'Latin']],
  ['pugn', ['fight', 'Latin']],
  ['pulchr', ['beautiful', 'Latin']],
  ['pulmon', ['lung', 'Latin']],
  ['pulver', ['dust', 'Latin']],
  ['pung', ['prick', 'Latin']],
  ['punct', ['prick', 'Latin']],
  ['puni', ['punish', 'Latin']],
  ['pup', ['doll', 'Latin']],
  ['pur', ['pure', 'Latin']],
  ['purg', ['cleanse', 'Latin']],
  ['purpur', ['purple', 'Latin']],
  ['put', ['prune, reckon', 'Latin']],
  ['pyg', ['rump', 'Greek']],
  ['pyl', ['gate', 'Greek']],
  ['pyr', ['heat, fire', 'Greek']],
  ['quadr', ['four', 'Latin']],
  ['quadragen', ['forty each', 'Latin']],
  ['quadragesim', ['fortieth', 'Latin']],
  ['quart', ['fourth', 'Latin']],
  ['quasi', ['as if', 'Latin']],
  ['quatern', ['four each', 'Latin']],
  ['quati', ['shake', 'Latin']],
  ['quass', ['shake', 'Latin']],
  ['quer', ['search, seek', 'Latin']],
  ['quesit', ['search, seek', 'Latin']],
  ['qui', ['rest', 'Latin']],
  ['quin', ['five each', 'Latin']],
  ['quindecim', ['fifteenth', 'Latin']],
  ['quinden', ['fifteen each', 'Latin']],
  ['quinque', ['five', 'Latin']],
  ['quint', ['fifth', 'Latin']],
  ['quot', ['how many, how great', 'Latin']],
  ['rad', ['scrape, shave', 'Latin']],
  ['ras', ['scrape, shave', 'Latin']],
  ['radi', ['beam, spoke', 'Latin']],
  ['radic', ['root', 'Latin']],
  ['ram', ['branch', 'Latin']],
  ['ran', ['frog', 'Latin']],
  ['ranc', ['rancidness, grudge, bitterness', 'Latin']],
  ['rap', ['turnip', 'Latin']],
  ['raph', ['seam', 'Greek']],
  ['rar', ['', 'Latin']],
  ['rauc', ['harsh, hoarse', 'Latin']],
  ['re', ['recede, redact', 'Latin']],
  ['red', ['again, back', 'Latin']],
  ['reg', ['straight', 'Latin']],
  ['rect', ['straight', 'Latin']],
  ['rem', ['oar', 'Latin']],
  ['ren', ['kidney', 'Latin']],
  ['rep', ['crawl, creep', 'Latin']],
  ['rept', ['crawl, creep', 'Latin']],
  ['ret', ['net', 'Latin']],
  ['retro', ['backward, behind', 'Latin']],
  ['rhabd', ['rod', 'Greek']],
  ['rhach', ['spine', 'Greek']],
  ['rach', ['spine', 'Greek']],
  ['rhag', ['tear, rent', 'Greek']],
  ['rhe', ['flow', 'Greek']],
  ['rhig', ['chill', 'Greek']],
  ['rhin', ['nose, snout', 'Greek']],
  ['rhiz', ['root', 'Greek']],
  ['rhod', ['rose', 'Greek']],
  ['rhomb', ['spinning top', 'Greek']],
  ['rhynch', ['snout', 'Greek']],
  ['rid', ['laugh', 'Latin']],
  ['ris', ['laugh', 'Latin']],
  ['robor', ['oak, strength', 'Latin']],
  ['ros', ['gnaw', 'Latin']],
  ['rog', ['ask', 'Latin']],
  ['rostr', ['beak, prow', 'Latin']],
  ['rot', ['wheel', 'Latin']],
  ['ruber', ['red', 'Latin']],
  ['rubr', ['red', 'Latin']],
  ['rug', ['wrinkle', 'Latin']],
  ['rumin', ['throat', 'Latin']],
  ['rump', ['break', 'Latin']],
  ['rupt', ['break', 'Latin']],
  ['rur', ['country', 'Latin']],
  ['sacchar', ['sugar', 'Greek']],
  ['sacr', ['sacred', 'Latin']],
  ['secr', ['sacred', 'Latin']],
  ['sagac', ['wise', 'Latin']],
  ['sagitt', ['arrow', 'Latin']],
  ['sal', ['salt', 'Latin']],
  ['sali', ['jump', 'Latin']],
  ['salt', ['jump', 'Latin']],
  ['salic', ['willow', 'Latin']],
  ['salv', ['save', 'Latin']],
  ['san', ['healthy', 'Latin']],
  ['sanc', ['holy', 'Latin']],
  ['sanguin', ['blood', 'Latin']],
  ['sapi', ['taste, wise', 'Latin']],
  ['sapon', ['soap', 'Latin']],
  ['sarc', ['flesh', 'Greek']],
  ['saur', ['lizard, reptile', 'Greek']],
  ['sax', ['rock', 'Latin']],
  ['scab', ['scratch', 'Latin']],
  ['scal', ['ladder, stairs', 'Latin']],
  ['scalen', ['uneven', 'Greek']],
  ['scand', ['climb', 'Latin']],
  ['scans', ['climb', 'Latin']],
  ['scaph', ['anything hollow, bowl, ship', 'Greek']],
  ['scel', ['leg, thigh', 'Greek']],
  ['schem', ['plan', 'Greek']],
  ['schis', ['split', 'Greek']],
  ['sci', ['know', 'Latin']],
  ['scind', ['split', 'Latin']],
  ['sciss', ['split', 'Latin']],
  ['scler', ['hard', 'Greek']],
  ['scoli', ['crooked', 'Greek']],
  ['scop', ['look at, examine, view, observe', 'Greek']],
  ['scept', ['look at, examine, view, observe', 'Greek']],
  ['scrib', ['write', 'Latin']],
  ['script', ['write', 'Latin']],
  ['sculp', ['carve', 'Latin']],
  ['scut', ['shield', 'Latin']],
  ['scyph', ['cup', 'Greek']],
  ['se', ['six', 'Latin']],
  ['sed', ['sit', 'Latin']],
  ['seb', ['tallow', 'Latin']],
  ['sec', ['cut', 'Latin']],
  ['sect', ['cut', 'Latin']],
  ['seg', ['cut', 'Latin']],
  ['sess', ['sit', 'Latin']],
  ['sedec', ['sixteen', 'Latin']],
  ['seget', ['in cornfields', 'Latin']],
  ['sei', ['shake', 'Greek']],
  ['selen', ['moon', 'Greek']],
  ['sell', ['saddle, seat', 'Latin']],
  ['sema', ['sign', 'Greek']],
  ['semi', ['half', 'Latin']],
  ['semin', ['seed', 'Latin']],
  ['sen', ['six each', 'Latin']],
  ['senti', ['feel', 'Latin']],
  ['sens', ['feel', 'Latin']],
  ['sept', ['seven', 'Latin']],
  ['septen', ['seven each', 'Latin']],
  ['septim', ['seventh', 'Latin']],
  ['septuagen', ['seventy each', 'Latin']],
  ['septuagesim', ['seventieth', 'Latin']],
  ['septuagint', ['seventy', 'Latin']],
  ['sequ', ['follow', 'Latin']],
  ['secut', ['follow', 'Latin']],
  ['ser', ['late', 'Latin']],
  ['sat', ['cultivate', 'Latin']],
  ['serp', ['crawl, creep', 'Latin']],
  ['serr', ['saw, saw-toothed', 'Latin']],
  ['serv', ['save, protect, serve', 'Latin']],
  ['sesqui', ['one and a half', 'Latin']],
  ['set', ['bristle, hair', 'Latin']],
  ['sever', ['stern, strict, serious', 'Latin']],
  ['sex', ['six', 'Latin']],
  ['sexagen', ['sixty each', 'Latin']],
  ['sexagesim', ['sixtieth', 'Latin']],
  ['sext', ['sixth', 'Latin']],
  ['sibil', ['hiss', 'Latin']],
  ['sicc', ['dry', 'Latin']],
  ['sider', ['star', 'Latin']],
  ['sign', ['sign', 'Latin']],
  ['sil', ['quiet or still', 'Latin']],
  ['silv(i)', ['forest', 'Latin']],
  ['simi', ['ape, monkey', 'Latin']],
  ['simil', ['likeness, trust, group', 'Latin']],
  ['simul', ['imitating, feigning', 'Latin']],
  ['singul', ['one each', 'Latin']],
  ['sinistr', ['left', 'Latin']],
  ['sinu', ['(to draw) a line', 'Latin']],
  ['sinus', ['hollow, bay', 'Latin']],
  ['siph(o)', ['tube', 'Greek']],
  ['sist', ['cause to stand', 'Latin']],
  ['sit', ['food, grain, wheat', 'Greek']],
  ['soci', ['group', 'Latin']],
  ['sol', ['alone, only', 'Latin']],
  ['solen', ['pipe, channel', 'Greek']],
  ['solv', ['loosen, set free', 'Latin']],
  ['solut', ['loosen, set free', 'Latin']],
  ['soma', ['body', 'Greek']],
  ['somn', ['sleep', 'Latin']],
  ['somni', ['dream', 'Latin']],
  ['son', ['sound', 'Latin']],
  ['soph', ['wise', 'Greek']],
  ['sorb', ['suck', 'Latin']],
  ['sorpt', ['suck', 'Latin']],
  ['sord', ['dirt', 'Latin']],
  ['soror', ['sister', 'Latin']],
  ['spati', ['space', 'Latin']],
  ['spec', ['look', 'Latin']],
  ['spect', ['watch, look at', 'Latin']],
  ['specul', ['observe', 'Latin']],
  ['sper', ['hope', 'Latin']],
  ['sperm', ['seed', 'Greek']],
  ['sphen', ['wedge', 'Greek']],
  ['spher', ['ball', 'Greek']],
  ['sphinct', ['closing', 'Greek']],
  ['spic', ['spike', 'Latin']],
  ['spin', ['thorn', 'Latin']],
  ['spir', ['breathe', 'Latin']],
  ['spond', ['a surety, guarantee; give assurance, promise solemnly', 'Latin']],
  ['spons', ['a surety, guarantee; give assurance, promise solemnly', 'Latin']],
  ['spondyl', ['vertebra spu-, sput- spew, spit', 'Latin']],
  ['squal', ['scaly, dirty, filthy', 'Latin']],
  ['squam', ['scale', 'Latin']],
  ['squarros', ['spreading at tips', 'Latin']],
  ['st', ['stand', 'Latin']],
  ['stagn', ['pool of standing water', 'Latin']],
  ['stalact', ['', 'Greek']],
  ['stalagm', ['', 'Greek']],
  ['stann', ['tin', 'Latin']],
  ['statu', ['stand', 'Latin']],
  ['stea', ['fat, tallow', 'Greek']],
  ['steg', ['covering', 'Greek']],
  ['stell', ['star', 'Latin']],
  ['sten', ['narrow', 'Greek']],
  ['stere', ['solid', 'Greek']],
  ['stern', ['breastbone', 'Greek']],
  ['strat', ['spread, strew', 'Latin']],
  ['stich', ['line, row', 'Greek']],
  ['stig', ['', 'Greek']],
  ['still', ['drip', 'Latin']],
  ['stimul', ['goad, rouse, excite', 'Latin']],
  ['stingu', ['apart', 'Latin']],
  ['stinct', ['apart', 'Latin']],
  ['stoch', ['aim', 'Greek']],
  ['stom', ['mouth', 'Greek']],
  ['strept', ['twisted', 'Greek']],
  ['strig', ['compress', 'Latin']],
  ['strigos', ['having stiff bristles', 'Latin']],
  ['string', ['upright, stiff', 'Latin']],
  ['strict', ['upright, stiff', 'Latin']],
  ['stroph', ['turning', 'Greek']],
  ['stru', ['to make up, build', 'Latin']],
  ['struct', ['to make up, build', 'Latin']],
  ['stud', ['dedication', 'Latin']],
  ['stup', ['wonder', 'Latin']],
  ['styl', ['column, pillar', 'Greek']],
  ['su', ['susbelow', 'Latin']],
  ['sut', ['sew', 'Latin']],
  ['sui', ['self', 'Latin']],
  ['suad', ['urge', 'Latin']],
  ['suas', ['urge', 'Latin']],
  ['suav', ['sweet', 'Latin']],
  ['sub', ['susbelow', 'Latin']],
  ['suf', ['susbelow', 'Latin']],
  ['sug', ['susbelow', 'Latin']],
  ['subter', ['under', 'Latin']],
  ['sucr', ['sugar', 'Latin']],
  ['sud', ['sweat', 'Latin']],
  ['sulc', ['furrow', 'Latin']],
  ['sum', ['take', 'Latin']],
  ['sumpt', ['take', 'Latin']],
  ['super', ['above, over', 'Latin']],
  ['supin', ['lying back', 'Latin']],
  ['supra', ['above, over', 'Latin']],
  ['surd', ['deaf', 'Latin']],
  ['surg', ['rise', 'Latin']],
  ['syn', ['with', 'Greek']],
  ['sy', ['with', 'Greek']],
  ['syl', ['with', 'Greek']],
  ['sym', ['with', 'Greek']],
  ['syring', ['pipe', 'Greek']],
  ['tac', ['be silent', 'Latin']],
  ['tach', ['swift', 'Greek']],
  ['taeni', ['ribbon', 'Greek']],
  ['tal', ['ankle', 'Latin']],
  ['tang', ['touch', 'Latin']],
  ['tact', ['touch', 'Latin']],
  ['tag', ['touch', 'Latin']],
  ['tapet', ['carpet', 'Latin']],
  ['tard', ['slow', 'Latin']],
  ['tars', ['ankle', 'Greek']],
  ['taur', ['bull', 'Latin']],
  ['tax', ['arrangement, order', 'Greek']],
  ['techn', ['art, skill', 'Greek']],
  ['teg', ['cover', 'Latin']],
  ['tect', ['cover', 'Latin']],
  ['tele', ['complete', 'Greek']],
  ['temn', ['cut', 'Greek']],
  ['tempor', ['time', 'Latin']],
  ['ten', ['hold', 'Latin']],
  ['tent', ['hold', 'Latin']],
  ['tend', ['stretch, strain', 'Latin']],
  ['tens', ['stretch, strain', 'Latin']],
  ['tenu', ['slender, thin', 'Latin']],
  ['tep', ['be warm', 'Latin']],
  ['ter', ['rub', 'Latin']],
  ['trit', ['third', 'Greek']],
  ['teret', ['rounded', 'Latin']],
  ['terg', ['wipe', 'Latin']],
  ['ters', ['wipe', 'Latin']],
  ['termin', ['boundary, limit, end', 'Latin']],
  ['tern', ['three each', 'Latin']],
  ['terr', ['dry land', 'Latin']],
  ['terti', ['third', 'Latin']],
  ['test', ['witness', 'Latin']],
  ['tetr', ['four', 'Greek']],
  ['tex', ['weave', 'Latin']],
  ['text', ['weave', 'Latin']],
  ['thalam', ['chamber, bed', 'Greek']],
  ['thalass', ['sea', 'Greek']],
  ['than', ['death', 'Greek']],
  ['the', ['put', 'Greek']],
  ['thus', ['god', 'Greek']],
  ['thel', ['', 'Greek']],
  ['theori', ['speculation', 'Greek']],
  ['ther', ['beast, animal', 'Greek']],
  ['therm', ['heat, warm', 'Greek']],
  ['thym', ['mood', 'Greek']],
  ['thyr', ['door', 'Greek']],
  ['thyre', ['large shield', 'Greek']],
  ['tim', ['be afraid', 'Latin']],
  ['ting', ['moisten', 'Latin']],
  ['tinct', ['moisten', 'Latin']],
  ['tom', ['cut', 'Greek']],
  ['ton', ['stretch', 'Greek']],
  ['top', ['place', 'Greek']],
  ['torn', ['cut', 'Latin']],
  ['torpe', ['numb', 'Latin']],
  ['torqu', ['twist', 'Latin']],
  ['tort', ['twist', 'Latin']],
  ['tot', ['all, whole', 'Latin']],
  ['tox', ['arrow, bow', 'Greek']],
  ['trab', ['beam', 'Latin']],
  ['trachy', ['rough', 'Greek']],
  ['trag', ['goat', 'Greek']],
  ['trah', ['draw, pull', 'Latin']],
  ['tract', ['draw, pull', 'Latin']],
  ['trans', ['across', 'Latin']],
  ['tra', ['across', 'Latin']],
  ['tran', ['across', 'Latin']],
  ['trapez', ['sided, table', 'Greek']],
  ['four', ['sided, table', 'Greek']],
  ['traum', ['wound', 'Greek']],
  ['trecent', ['three hundred', 'Latin']],
  ['tredec', ['thirteen', 'Latin']],
  ['treiskaidek', ['thirteen', 'Greek']],
  ['trem', ['tremble', 'Latin']],
  ['trema', ['hole', 'Greek']],
  ['tri', ['three', 'Latin']],
  ['tricen', ['thirty each', 'Latin']],
  ['tricesim', ['thirtieth', 'Latin']],
  ['trigesim', ['thirtieth', 'Latin']],
  ['trich', ['hair', 'Greek']],
  ['trin', ['three each', 'Latin']],
  ['troch', ['wheel', 'Greek']],
  ['trop', ['turning', 'Greek']],
  ['troph', ['feed, grow', 'Greek']],
  ['trud', ['thrust', 'Latin']],
  ['trus', ['thrust', 'Latin']],
  ['tuss', ['cough', 'Latin']],
  ['tympan', ['drum', 'Greek']],
  ['typ', ['stamp, model', 'Greek']],
  ['uber', ['fruitful', 'Latin']],
  ['uligin', ['in marshes', 'Latin']],
  ['ulo', ['wooly', 'Greek']],
  ['ultim', ['farthest', 'Latin']],
  ['ultra', ['beyond', 'Latin']],
  ['umbilic', ['navel', 'Latin']],
  ['umbr', ['shade, shadow', 'Latin']],
  ['unc', ['hooked', 'Latin']],
  ['unci', ['ounce, twelfth', 'Latin']],
  ['und', ['wave', 'Latin']],
  ['undecim', ['eleventh', 'Latin']],
  ['unden', ['eleven each', 'Latin']],
  ['ungui', ['claw, nail', 'Latin']],
  ['ungul', ['claw, hoof', 'Latin']],
  ['ur', ['urine', 'Greek']],
  ['uro', ['urine', 'Greek']],
  ['urb', ['city', 'Latin']],
  ['urg', ['work', 'Latin']],
  ['urs', ['bear', 'Latin']],
  ['ut', ['use', 'Latin']],
  ['us', ['use', 'Latin']],
  ['uv', ['grape', 'Latin']],
  ['uxor', ['wife', 'Latin']],
  ['vac', ['empty', 'Latin']],
  ['vad', ['go', 'Latin']],
  ['vas', ['go', 'Latin']],
  ['vag', ['wander', 'Latin']],
  ['van', ['empty, vain, idle', 'Latin']],
  ['vap', ['lack (of)', 'Latin']],
  ['veh', ['carry', 'Latin']],
  ['vect', ['carry', 'Latin']],
  ['vel', ['veil', 'Latin']],
  ['vell', ['pull', 'Latin']],
  ['vuls', ['pull', 'Latin']],
  ['veloc', ['quick', 'Latin']],
  ['ven', ['come', 'Latin']],
  ['vent', ['wind', 'Latin']],
  ['vend', ['sell', 'Latin']],
  ['vener', ['respectful', 'Latin']],
  ['ventr', ['belly', 'Latin']],
  ['ver', ['true', 'Latin']],
  ['verb', ['word', 'Latin']],
  ['verber', ['whip', 'Latin']],
  ['verm', ['worm', 'Latin']],
  ['vern', ['spring', 'Latin']],
  ['vert', ['turn', 'Latin']],
  ['vers', ['turn', 'Latin']],
  ['vesic', ['bladder', 'Latin']],
  ['vesper', ['evening, western', 'Latin']],
  ['vest', ['clothe, garment', 'Latin']],
  ['vestig', ['track', 'Latin']],
  ['vet', ['forbid', 'Latin']],
  ['veter', ['old', 'Latin']],
  ['vi', ['way', 'Latin']],
  ['vic', ['change', 'Latin']],
  ['vicen', ['twenty', 'Latin']],
  ['vigen', ['twenty', 'Latin']],
  ['vicesim', ['twentieth', 'Latin']],
  ['vigesim', ['twentieth', 'Latin']],
  ['vid', ['see', 'Latin']],
  ['vis', ['see', 'Latin']],
  ['vil', ['cheap', 'Latin']],
  ['vill', ['shaggy hair, velvet', 'Latin']],
  ['vin', ['wine', 'Latin']],
  ['vinc', ['conquer', 'Latin']],
  ['vict', ['conquer', 'Latin']],
  ['vir', ['green', 'Latin']],
  ['visc', ['thick', 'Latin']],
  ['viscer', ['organs of the body cavity', 'Latin']],
  ['vit', ['life', 'Latin']],
  ['vitell', ['yolk', 'Latin']],
  ['viti', ['fault', 'Latin']],
  ['vitr', ['glass', 'Latin']],
  ['viv', ['live', 'Latin']],
  ['voc', ['voice', 'Latin']],
  ['vol', ['wish', 'Latin']],
  ['volv', ['roll', 'Latin']],
  ['volut', ['roll', 'Latin']],
  ['vom', ['discharge', 'Latin']],
  ['vor', ['swallow', 'Latin']],
  ['vorac', ['swallow', 'Latin']],
  ['vov', ['vow', 'Latin']],
  ['vot', ['vow', 'Latin']],
  ['vulg', ['common, crowd', 'Latin']],
  ['vulner', ['wound', 'Latin']],
  ['vulp', ['fox', 'Latin']],
  ['xanth', ['yellow', 'Greek']],
  ['xen', ['foreign', 'Greek']],
  ['xer', ['dry', 'Greek']],
  ['xiph', ['sword', 'Greek']],
  ['xyl', ['wood', 'Greek']],
  ['zo', ['animal, living being', 'Greek']],
  ['zon', ['belt, girdle', 'Greek']],
  ['zyg', ['yoke', 'Greek']],
  ['zym', ['ferment', 'Greek']],
  ])